import React from 'react';

const SvgIconMenu = (props) => (
  <svg width={40} height={40} {...props}>
    <g fillRule="nonzero" fill="none">
      <path fill="#F5F5F5" d="M0 0h40v40H0z" />
      <path d="M8 10v2h24v-2H8zm0 9v2h24v-2H8zm0 9v2h24v-2H8z" fill="#E25D34" />
    </g>
  </svg>
);

export default SvgIconMenu;
